import { CUSTOMERS_CUSTOM_METRIC_EXPLAINER_IMGS } from "constants/customers";
import type {
  Process,
  ManyRollupsWithTagsAndRange,
} from "../../../types/types";
import { METRICS_WITH_CUSTOM_TOOLTIP_EXPLAINERS } from "../ExplainerTooltip";

export const GROUP_METRIC_WIDTH = { sm: 64, md: 74, lg: 84 };
export const GROUP_METRIC_HEIGHT = 60;
export const GROUP_METRIC_MARGIN_HZ = 10;

export function filterRollupsByVisibleAndSelectedProcesses(
  visibleProcesses: Process[],
  selectedProcessIdsRef: { current: string[] },
  rollupsMetricToDisplay: ManyRollupsWithTagsAndRange
): ManyRollupsWithTagsAndRange {
  const visibleProcIds = visibleProcesses.map(proc => proc?.id);
  // for a serial or manually filtered process,
  // also check if the process is in the selected process ids
  const processIds = visibleProcIds.filter(procId =>
    selectedProcessIdsRef.current.includes(procId)
  );
  return Object.entries(rollupsMetricToDisplay)
    .filter(([procId]) => processIds.includes(procId))
    .reduce((acc, [procId, processRollup]) => {
      acc[procId] = processRollup;
      return acc;
    }, {} as ManyRollupsWithTagsAndRange);
}

export function getShowTooltip({
  description,
  dataDumpKey,
  ckey,
}: {
  description: string | undefined;
  dataDumpKey: string | undefined;
  ckey: string;
}): boolean {
  return Boolean(
    description ||
      (dataDumpKey &&
        (METRICS_WITH_CUSTOM_TOOLTIP_EXPLAINERS[dataDumpKey] ||
          CUSTOMERS_CUSTOM_METRIC_EXPLAINER_IMGS[ckey]?.[dataDumpKey]))
  );
}
